/**
 * Phase 17.0 — Stripe Connect refresh page.
 *
 * Stripe redirects here if the onboarding URL expired before the creator
 * finished. We auto-request a fresh link and forward them to it.
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";

export default function StripeConnectRefreshPage() {
  const navigate = useNavigate();
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await api.post("/stripe/connect/refresh-link");
        if (cancelled) return;
        const url = r?.data?.onboarding_url;
        if (url) {
          window.location.assign(url);
        } else {
          setErr("No onboarding URL returned");
        }
      } catch (e) {
        if (cancelled) return;
        const d = e?.response?.data?.detail;
        setErr(typeof d === "string" ? d : "Couldn't refresh Stripe onboarding link");
        toast.error("Could not refresh Stripe link");
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="min-h-screen bg-[#0b0b13] text-white flex items-center justify-center px-4">
      <div className="max-w-md w-full rounded-2xl border border-white/10 bg-white/5 p-6 text-center"
           data-testid="stripe-connect-refresh-page">
        <div className="text-5xl mb-3">🔄</div>
        <h1 className="text-2xl font-black mb-2">Refreshing Stripe Link…</h1>
        {!err ? (
          <p className="text-sm text-gray-400">
            One moment — generating a fresh onboarding URL.
          </p>
        ) : (
          <>
            <p className="text-sm text-rose-300 mb-4">{err}</p>
            <Button onClick={() => navigate("/payouts")}
                    className="bg-emerald-500 hover:bg-emerald-600 text-black font-bold"
                    data-testid="stripe-refresh-goto-payouts-btn">
              Back to Payouts
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
